module.exports="#define GLSLIFY 1\nuniform float time; \n\nvoid main()\t{\n\n    gl_FragColor = vec4(vec3(1.,0.,0.), 1.);\n\n}";